import { render, staticRenderFns } from "./navigation-tpl.vue?vue&type=template&id=2b96ab71&scoped=true"
import script from "./navigation-tpl.vue?vue&type=script&lang=js"
export * from "./navigation-tpl.vue?vue&type=script&lang=js"
import style0 from "./navigation-tpl.vue?vue&type=style&index=0&id=2b96ab71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b96ab71",
  null
  
)

export default component.exports